import { Tag } from 'primereact/tag'

const PlanBadge = ({ planType }) => {
  const getBadgeProps = (type) => {
    const planName = type?.toLowerCase()
    switch (planName) {
      case 'premium':
        return {
          value: 'Premium',
          severity: 'success',
          style: {
            backgroundColor: 'transparent',
            color: '#d4af37',
            padding: '0.3rem 0.60rem',
            borderRadius: '0.5rem',
            fontSize: '0.650rem',
            border: '1px solid #d4af37'
          }
        }
      case 'basic':
        return {
          value: 'Basic',
          severity: 'info',
          style: {
            backgroundColor: 'transparent',
            color: '#3ab44d',
            padding: '0.3rem 0.60rem',
            borderRadius: '0.5rem',
            fontSize: '0.650rem',
            border: '1px solid #3ab44d'
          }
        }
      default:
        return {
          value: 'Basic',
          severity: 'info',
          style: {
            backgroundColor: 'transparent',
            color: '#3ab44d',
            padding: '0.3rem 0.60rem',
            borderRadius: '0.5rem',
            fontSize: '0.650rem',
            border: '1px solid #3ab44d'
          }
        }
    }
  }

  const badgeProps = getBadgeProps(planType)

  return (
    <div className="flex align-items-center justify-content-center">
      <Tag 
        {...badgeProps}
        className="flex align-items-center gap-1"
      />
    </div>
  )
}

export default PlanBadge